export default "__VITE_ASSET__BuBHZdyX__"